import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center pb-16"},[_c(VBtn,{attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"color":"primary","elevation":"24","rounded":"","x-large":""},on:{"click":function($event){return _vm.$emit("click")}}},[_vm._t("default",function(){return [_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-check")]),_vm._v(" Okay")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }